import React from 'react';

export default function SplashScreen() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50 flex flex-col items-center justify-center">
      <div className="animate-pulse flex flex-col items-center">
        <img src="/logo.png" alt="BuildMyShifts" className="w-20 h-20 object-contain mb-6" />
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Build My <span className="text-primary">Shifts</span>
        </h1>
        <p className="text-gray-500 text-sm">Smart Shift Planning</p>
        <div className="mt-8">
          <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
        </div>
      </div>
    </div>
  );
}
